'use client'

/* ============================================================
   RR Design System — ThemeSegmentedToggle
   A 3-state segmented pill (Light / Dark / System) intended
   to live inside menus / dropdowns where a full picker is
   appropriate. Drives the shared rr-ui ThemeProvider.
   ============================================================ */

import { Laptop, Moon, Sun } from 'lucide-react'
import { useTheme, type ThemePreference } from './theme-provider'
import { SegmentedPicker } from '../components/ui/segmented-picker'

export interface ThemeSegmentedToggleProps {
  className?: string
  label?: string
  labels?: { light?: string; dark?: string; system?: string }
  /** When true, only show the theme icons (Sun, Moon, Laptop) without text labels. */
  iconsOnly?: boolean
}

export function ThemeSegmentedToggle({
  className,
  label,
  labels,
  iconsOnly,
}: ThemeSegmentedToggleProps) {
  const { theme, setTheme } = useTheme()

  return (
    <SegmentedPicker<ThemePreference>
      className={className}
      label={label}
      value={theme}
      onChange={setTheme}
      iconsOnly={iconsOnly}
      options={[
        {
          value: 'light',
          label: labels?.light ?? 'Light',
          icon: Sun,
          activeIconClassName: 'text-amber-500',
        },
        {
          value: 'dark',
          label: labels?.dark ?? 'Dark',
          icon: Moon,
          activeIconClassName: '-rotate-12 text-indigo-400',
        },
        {
          value: 'system',
          label: labels?.system ?? 'System',
          icon: Laptop,
          activeIconClassName: 'text-primary',
        },
      ]}
    />
  )
}
